import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'
import { JobType } from '@src/types/JobType'

interface Options {
  srrId: number | string,
  serialId: number,
  jobType: JobType,
}

export const apiSrrReworkRemove = (options: Options) => {
  const { 
    srrId, 
    serialId,
    jobType,
  } = options

  const asOrSs = jobType === JobType.Asphalt ? 'asphalt' : 'sprayseal'
  const oneOrTwo = jobType === JobType.Asphalt ? 1 : 2
  const axOptions = {
    method: 'DELETE',
    url: `${BASE_API_URL}/v2/srr/${srrId}/rework/${asOrSs}/details/${oneOrTwo}`,
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}